import React from "react";
import XuronLogo from "../img/logo2.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SideMenuAdminsLinks, SideMenuLinks } from "../data/sidemenu";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";

type Props = {
  onNavigate?: () => void;
};

const SideMenu: React.FC<Props> = ({ onNavigate }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { clearAuth, role } = useAuth();

  let selectedLinks = [] as any;

  if (role === "org_admin") {
    selectedLinks = SideMenuAdminsLinks;
  } else if (role === "super_admin") {
    selectedLinks = SideMenuLinks;
  }

  return (
    <nav className="flex h-full w-full flex-col overflow-hidden bg-white">
      {/* Header */}
      <div className="flex items-center justify-center gap-2 border-b border-gray-200 px-4 py-4">
        <img src={XuronLogo} className="h-5 w-auto" alt="Xuron" />
      </div>

      {/* Links */}
      <div className="flex-1 overflow-y-auto px-3 py-4">
        <ul className="flex flex-col gap-2 h-full">
          {selectedLinks.map((link: any) => {
            const active = pathname === link.link || pathname.startsWith(link.link + "/");
            return (
              <li key={link.text}>
                <Link
                  to={link.link}
                  onClick={onNavigate}
                  className={[
                    "group flex items-center gap-2 rounded-full px-3 py-2 text-base font-medium transition-colors",
                    active ? "bg-xuron-orange text-white" : "text-gray-500 hover:bg-gray-100",
                  ].join(" ")}
                >
                  <link.icon
                    className={[
                      "h-5 w-5 transition-colors",
                      active ? "!stroke-white" : "!stroke-gray-500 group-hover:!stroke-gray-700",
                    ].join(" ")}
                  />
                  <span className="truncate">{t(link.text)}</span>
                </Link>
              </li>
            );
          })}
          <button
            onClick={() => {
              navigate("/");
              clearAuth();
            }}
            className="w-full mt-auto mb-4 top-auto flex items-center gap-2 px-3 py-2 rounded-full bg-red-50 text-red-600 font-medium text-base hover:bg-red-100"
          >
            <LogOut className="w-5 h-5" /> Log Out
          </button>
        </ul>
      </div>

      {/* Optional footer / version / sign out area could go here */}
    </nav>
  );
};

export default SideMenu;
